<template>
  <Label class="flex items-center block mb-2 text-secondary-dark" :class="labelClass" :is="'span'">
    <slot />
    <ChangeIndicator
      v-if="isDirty && !disabled && Control.resettable"
      :class="indicatorClass"
      @click="handleReset()"
    />

    <BreakpointSwitch v-if="responsive" />
    <Icon
      v-if="tippy"
      v-tippy="{
        interactive: true,
        offset: '45 0',
        boundary: 'window',
      }"
      class="ml-2 cursor-pointer text-dull"
      :content="tippy"
      name="info-circle"
    />
    <slot name="after" />
    <Typography
      v-if="error"
      variant="caption"
      class="block mt-2"
      style="color: red"
    >
      {{ error }}
    </Typography>
  </Label>
</template>

<script>
import Icon from '@converdy/atoms/Icon';
import Label from '@converdy/atoms/Label';
import BreakpointSwitch from '@converdy/components/BreakpointSwitch';
import control from '../control';

export default {
  props: ['disabled', 'tippy', 'error'],

  mixins: [control],

  components: {
    BreakpointSwitch,
  },

  methods: {
    handleIconClick(e) {
      this.$emit('reset', e);
    },
  },

  computed: {
    isDirty() {
      return this.dirty();
    },
    labelClass() {
      return [
        this.$style.label,
        {
          [this.$style.dirty]: this.isDirty,
        },
      ];
    },

    indicatorClass() {
      return [
        this.$style.indicator,
        {
          [this.$style.dirty]: this.isDirty,
        },
      ];
    },

    iconClass() {
      return [
        this.$style.icon,
        {
          [this.$style.dirty]: this.isDirty,
        },
      ];
    },
  },
};
</script>

<style module>
.label {
  @apply text-sm;
}

.indicator {
  visibility: hidden;
}

.indicator.dirty {
  visibility: visible;
}

.icon {
  visibility: hidden;
  cursor: pointer;
}

.label.dirty:hover .icon {
  visibility: visible;
}
</style>
